import React, { useState, useEffect } from "react"
import withLocation from "../../utils/withLocation"
import ProductsResults from "./productsResults"
import ProjectsResults from "./projectsResults"
import algoliasearch from "algoliasearch/lite"
import { Row, Tabs, Tab } from "react-bootstrap"
import qs from "qs"
import { InstantSearch, connectSearchBox } from "react-instantsearch-dom"

const DEBOUNCE_TIME = 400
const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY
)

const algoliaIndex = process.env.GATSBY_ALGOLIA_INDEX_NAME || "Products"

const VirtualSearchBox = connectSearchBox(() => null)

const createURL = (state) => `?${qs.stringify(state)}`

const searchStateToUrl = (location, searchState) => {
  let result = searchState
    ? `${location.pathname}${createURL(searchState)}`
    : ""
  return result
}

const isObjectEmpty = (obj) => {
  if (!obj) return true
  return Object.entries(obj).length === 0 && obj.constructor === Object
}

const urlToSearchState = ({ search }) => {
  return qs.parse(search.slice(1))
}

const SearchModule = ({
  location,
  navigate,
  searchFilters,
  showTitle,
  showSelector,
  showProjects,
  hitComponent,
  categoryName,
  subCategoryName,
  material,
  use,
  style,
  type
}) => {
  const [searchState, setSearchState] = useState({})
  const [debouncedSetState, setDebouncedSetState] = useState(null)
  const [productCount, setProductCount] = useState(0)
  const [projectCount, setProjectCount] = useState(0)

  useEffect(() => {
    var searchParams = {}

    if (!isObjectEmpty(searchFilters)) {
      searchParams = Object.assign(searchParams, searchFilters)
    }
    if (location.state && location.state.category) {
      searchParams = Object.assign(searchParams, {
        hierarchicalMenu: { "categories.lvl0": location.state.category },
      })
    }

    let refinementList = {}
    if (material) {
      refinementList = Object.assign(refinementList, {
        material: [material],
      })
    }
    if (style) {
      refinementList = Object.assign(refinementList, {
        style: [style],
      })
    }
    if (use) {
      refinementList = Object.assign(refinementList, {
        use: [use],
      })
    }
    if (type) {
      refinementList = Object.assign(refinementList, {
        type: [type]
      })
    }
    if (categoryName) {
      if (subCategoryName) {
        refinementList = Object.assign(refinementList, {
          category: [categoryName],
          subCategory: [subCategoryName],
        })
      } else {
        refinementList = Object.assign(refinementList, {
          category: [categoryName],
        })
      }
    }

    searchParams = Object.assign(searchParams, {
      indices: {
        production_PROJECTS: {
          refinementList: refinementList,
        },
      },
    })

    let intendedSearchState = urlToSearchState(location)

    searchParams = Object.assign(searchParams, intendedSearchState)

    setSearchState(searchParams)
  }, [searchFilters, location, categoryName])

  const onSearchStateChange = (updatedSearchState) => {
    clearTimeout(debouncedSetState)

    setDebouncedSetState(
      setTimeout(() => {
        navigate(searchStateToUrl(location, updatedSearchState), {
          state: updatedSearchState,
        })
      }, DEBOUNCE_TIME)
    )

    setSearchState(updatedSearchState)
  }

  return (
    <>
      <InstantSearch
        indexName={algoliaIndex}
        searchClient={searchClient}
        searchState={searchState}
        onSearchStateChange={onSearchStateChange}
        createURL={createURL}
      >
        <VirtualSearchBox />

        {showTitle && (
          <>
            <div className="searchheader">
              <h2 className="generalheader">
                Search Results for: {searchState.query}
              </h2>
            </div>
            <br />
          </>
        )}

        {showSelector && (
          <Tabs defaultActiveKey="products" id="uncontrolled-tab-example">
            <Tab
              tabClassName="product_tab_title"
              eventKey="products"
              title={`Products (${productCount})`}
            >
              <ProductsResults onCountChange={setProductCount} />
            </Tab>
            <Tab
              tabClassName="project_tab_title"
              eventKey="projects"
              title={`Custom Projects (${projectCount})`}
            >
              <ProjectsResults onCountChange={setProjectCount} />
            </Tab>
          </Tabs>
        )}

        {showProjects && (
          <ProjectsResults
            hitComponent={hitComponent}
            showCategory={false}
            showSubCategory={false}
          />
        )}
      </InstantSearch>
    </>
  )
}

SearchModule.defaultProps = {
  showTitle: true,
  showSelector: true,
  showProjects: false,
  selectedObject: "Products",
  filterState: {},
}

export default withLocation(SearchModule)
